module.exports = __webpack_public_path__ + "media/images/emblems/Sevelen-coat_of_arms-5f2537ca3d0a55cd3b6d4aaeb6563582.svg";